import update from 'immutability-helper';
import moment from "moment";

const initialState = {

    items: {},
    fetching: false,
    fetched: false,
    saving: false,

    newsletter: {
        saving: false,
        saved: false,
    }

};
export default (state = initialState, action) => {

    switch (action.type) {

        case "FETCH_STATIC_TEXTS":
            return update(state, {
                fetching: {$set: true},
                fetched: {$set: false},
            });
        case "SAVE_STATIC_TEXT":
            return update(state, {
                saving: {$set: true},
            });
        case "SAVED_NEWSLETTER":
            return update(state, {
                newsletter: {
                    saving: {$set: false},
                    saved: {$set: true},
                }
            });
        case "SAVING_NEWSLETTER":
            return update(state, {
                newsletter: {
                    saving: {$set: true},
                    saved: {$set: false},
                }
            });
        case "SAVED_STATIC_TEXT":
            const text = action.payload;

            return update(state, {
                saving: {$set: false},
                items: {
                    [text.id]: {$set: text}
                },
            });

        case "FETCHED_STATIC_TEXTS":

            const {items} = action.payload;

            let itemsById = {};
            for (let item of items) {
                itemsById[item.id] = item;
            }

            return update(state, {
                fetching: {$set: false},
                fetched: {$set: true},
                items: {$set: itemsById},
            });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/StaticTextsReducer.js